import React from 'react';
import {Button, CircularProgress, FormControl, TextField, Typography} from "@material-ui/core";
import {connect} from "react-redux";
import {KeyboardArrowLeft, KeyboardArrowRight, Visibility, VisibilityOff} from "@material-ui/icons";
import Graph from "../../icons/SVGs/ArrowLeft.svg";
import image_1 from "../../icons/img/info/1.png";
import image_2 from "../../icons/img/info/2.png";
import image_3 from "../../icons/img/info/3.png"
import logo from "../../icons/img/CropSense.png"
import {IStore} from "../../store/reducers";
import actionTypes from "../../store/actionTypes";
import {INotificacion} from "../../types";
import axios from "axios";
import config from "../../config.json";
import moment from "moment";
import Planes from "./Planes";
import Payments from "./Payments";
const texts = require('../../texts/login.json')


interface IProps {
    idioma: string
    notify(notification: INotificacion): void
    setContacta(contacta: boolean): void
    setUser(user: string): void
    setGo2App(go2app: boolean): void
}

interface IState {
    imagen: number
    vertical: boolean
    cambiando: boolean
    text: Record<string, string>
    crearCuenta: boolean
    user: string
    pass: string
    confirm_pass: string
    error_user: boolean
    error_pass: string
    error_confirm_pass: boolean
    view_pass: boolean
    view_confirm_pass: boolean
    hover: string
    pagos: boolean
    plan: number
    precio: number
    parcelas: number
    superficie: number
    duracion: number
    pagar: boolean
    loading: boolean
    email: string
    location: string
}

class MobileLoginCreate extends React.Component<IProps, IState> {
    state: IState = {
        text: texts[this.props.idioma],
        imagen: 1,
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        crearCuenta: true,
        user: "",
        pass: "",
        confirm_pass: "",
        error_user: false,
        error_pass: '',
        error_confirm_pass: false,
        view_pass: false,
        view_confirm_pass: false,
        hover: "",
        pagos: false,
        plan: 1,
        precio: 0,
        parcelas: 0,
        superficie: 0,
        duracion: 0,
        pagar: false,
        loading: false,
        email: "",
        location: ""
    };

    componentDidMount() {
        axios.get("http://ip-api.com/json")
            .then((res) => {
                this.setState({
                    location: res.data.countryCode.toLowerCase()
                })
            })
    }

    handleName = (name: string) => {
        const ok_caracteres = "qwertyuiopasdfghjklñzxcvbnmQWERTYUIOPASDFGHJKLÑZXCVBNM1234567890-_"
        let ok_name = ""

        for (let i = 0; i < name.length; i++) {
            if (ok_caracteres.includes(name[i])) ok_name += name[i]
        }

        this.setState({user: ok_name})
    }

    handleCreate = () => {
        if (this.state.user === '') {
            this.setState({error_user: true})
            this.setState({pagos: false})
            return
        }

        if (this.state.pass.length < 6) {
            this.setState({error_pass: this.state.text["13"]})
            this.setState({pagos: false})
            return
        }

        if (this.state.pass !== this.state.confirm_pass) {
            this.setState({error_confirm_pass: true})
            this.setState({pagos: false})
            return
        }

        axios.get(
            config.url+`/nombre/disponible?nombre=${this.state.user}`
        )
            .then((res) => {
                if (!res.data["disponible"]) {
                    this.setState({error_user: true})
                    this.setState({pagos: false})
                    return
                }
                axios.get(
                    config.url+`/crear/usuario/gratuito?user=${this.state.user}&pass=${this.state.pass}&fecha_creacion=${moment(new Date()).format('DD-MM-YYYY')}`
                )
                    .then((res) => {
                        if (!window.location.pathname.split("/").includes("register")) {
                            this.props.notify({message: this.state.text["26"], variant: 'success'})
                            this.props.setUser(this.state.user)
                            this.props.setContacta(false)
                        } else {
                            this.props.notify({message: this.state.text["26"], variant: 'success'})
                            this.props.setGo2App(true)
                        }
                    })
                    .catch(() => {
                        this.props.notify({message: this.state.text["27"], variant: 'error'})
                        return
                    })
            })
            .catch(() => {
                this.props.notify({message: this.state.text["27"], variant: 'error'})
                return
            })
    }

    createAccount = async () => {
        axios.get(
            config.url+`/nombre/disponible?nombre=${this.state.user}`
        )
            .then((res) => {
                if (!res.data["disponible"]) {
                    this.setState({error_user: true, pagos: false, pagar: false})
                    this.props.notify({message: this.state.text["36"], variant: 'warning'})
                    return false
                }
                axios.get(
                    config.url+`/crear/usuario/gratuito?user=${this.state.user}&pass=${this.state.pass}&fecha_creacion=${moment(new Date()).format('DD-MM-YYYY')}`
                )
                    .then(() => {
                        return true
                    })
                    .catch(() => {
                        this.props.notify({message: this.state.text["35"], variant: 'error'})
                        return false
                    })
            })
            .catch(() => {
                this.props.notify({message: this.state.text["35"], variant: 'error'})
                return false
            })
    }


    handleGoToPagos = () => {
        if (this.state.user === '') {
            this.setState({error_user: true})
            this.setState({pagos: false})
            return
        }

        if (this.state.pass.length < 6) {
            this.setState({error_pass: this.state.text["13"]})
            this.setState({pagos: false})
            return
        }

        if (this.state.pass !== this.state.confirm_pass) {
            this.setState({error_confirm_pass: true})
            this.setState({pagos: false})
            return
        }

        axios.get(
            config.url+`/nombre/disponible?nombre=${this.state.user}`
        )
            .then((res) => {
                if (!res.data["disponible"]) {
                    this.setState({error_user: true})
                    this.setState({pagos: false})
                    return
                }
                this.setState({pagos: true})
            })
            .catch(() => {
                this.props.notify({message: this.state.text["27"], variant: 'error'})
                return
            })
    }

    changePlan = (plan: number) => {
        this.setState({plan: plan})
    }

    changePrecio = (precio: number) => {
        this.setState({precio: precio})
    }

    changeParcelas = (parcelas: number) => {
        this.setState({parcelas: parcelas})
    }

    changeSuperficie = (superficie: number) => {
        this.setState({superficie: superficie})
    }

    changeDuracion = (duracion: number) => {
        this.setState({duracion: duracion})
    }

    setLoading = (loading: boolean) => {
        this.setState({loading: loading})
    }

    setEmail = (email: string) => {
        this.setState({email: email})
    }

    render() {

        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false);

        if (this.state.cambiando) {
            return null
        }


        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    height: '100vh',
                    width: '100vw',
                    overflow: "auto"
                }}
            >

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        width: '100%',
                        height: '100%'
                    }}
                >

                    <div
                        style={{
                            alignSelf: "flex-end",
                            display: "flex",
                            flexDirection: "row",
                            width: '40%',
                            justifyContent: "space-between",
                            marginTop: 30
                        }}
                    >
                        {!this.state.pagos && !this.state.pagar ?
                            <img
                                width='70%'
                                src={logo}
                                alt=''
                            />
                            :
                            <div style={{width: '70%'}}/>
                        }
                        {!window.location.pathname.split("/").includes("register") &&
                            <img
                                style={{
                                    height: 50,
                                    width: 50,
                                    cursor: "pointer",
                                    marginRight: 30
                                }}
                                src={Graph}
                                alt="wthr img"
                                onClick={() => this.props.setContacta(false)}
                            />
                        }

                    </div>

                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            width: '100%',
                            height: '80%',
                        }}
                    >

                        {!this.state.pagos && !this.state.pagar &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: '80%',
                                    height: '80%',
                                    marginTop: 20
                                }}
                            >
                                <TextField
                                    error={this.state.error_user}
                                    label={this.state.error_user? this.state.text["28"] : this.state.text["29"]}
                                    style={{width: 300, margin: 20}}
                                    className="inputRounded"
                                    inputProps={{style: {fontSize: 20, fontFamily: "Poppins"}}}
                                    InputLabelProps={{style: {fontSize: 20, fontFamily: "Poppins"}}}
                                    variant="outlined"
                                    value={this.state.user}
                                    onChange={e => {
                                        if (this.state.error_user) this.setState({error_user: false})
                                        this.handleName(e.target.value)
                                    }}
                                />

                                <FormControl
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: 330,
                                    }}
                                >
                                    <TextField
                                        error={this.state.error_pass !== ''}
                                        label={this.state.error_pass !== ''? this.state.error_pass : this.state.text["1"]}
                                        style={{width: 300, margin: 20, marginLeft: -15}}
                                        className="inputRounded"
                                        inputProps={{style: {fontSize: 20, fontFamily: "Poppins"}}}
                                        InputLabelProps={{style: {fontSize: 20, fontFamily: "Poppins"}}}
                                        variant="outlined"
                                        value={this.state.pass}
                                        type={this.state.view_pass? 'text' : 'password'}
                                        onChange={e => {
                                            if (this.state.error_pass !== '') this.setState({error_pass: ''})
                                            this.setState({pass: e.target.value})
                                        }}
                                    />
                                    {this.state.view_pass?
                                        <Visibility
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: "pointer",
                                                color: this.state.hover === 'view_pass'? "black" : '#4C494B',
                                                marginLeft: -60,
                                                zIndex: 10
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'view_pass'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            onClick={() => this.setState({view_pass: false})}
                                        />
                                        :
                                        <VisibilityOff
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: "pointer",
                                                color: this.state.hover === 'view_pass'? "black" : '#4C494B',
                                                marginLeft: -60,
                                                zIndex: 10
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'view_pass'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            onClick={() => this.setState({view_pass: true})}
                                        />
                                    }
                                </FormControl>

                                <FormControl
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: 330,
                                    }}
                                >
                                    <TextField
                                        error={this.state.error_confirm_pass}
                                        label={this.state.error_confirm_pass? this.state.text["30"] : this.state.text["31"]}
                                        style={{width: 300, margin: 20, marginLeft: -15}}
                                        className="inputRounded"
                                        inputProps={{style: {fontSize: 20, fontFamily: "Poppins"}}}
                                        InputLabelProps={{style: {fontSize: 20, fontFamily: "Poppins"}}}
                                        variant="outlined"
                                        value={this.state.confirm_pass}
                                        type={this.state.view_confirm_pass? 'text' : 'password'}
                                        onChange={e => {
                                            if (this.state.error_confirm_pass) this.setState({error_confirm_pass: false})
                                            this.setState({confirm_pass: e.target.value})
                                        }}
                                    />
                                    {this.state.view_confirm_pass?
                                        <Visibility
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: "pointer",
                                                color: this.state.hover === 'view_confirm_pass'? "black" : '#4C494B',
                                                marginLeft: -60,
                                                zIndex: 10
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'view_confirm_pass'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            onClick={() => this.setState({view_confirm_pass: false})}
                                        />
                                        :
                                        <VisibilityOff
                                            style={{
                                                width: 30,
                                                height: 30,
                                                cursor: "pointer",
                                                color: this.state.hover === 'view_confirm_pass'? "black" : '#4C494B',
                                                marginLeft: -60,
                                                zIndex: 10
                                            }}
                                            onMouseEnter={() => this.setState({hover: 'view_confirm_pass'})}
                                            onMouseLeave={() => this.setState({hover: ''})}
                                            onClick={() => this.setState({view_confirm_pass: true})}
                                        />
                                    }
                                </FormControl>

                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-evenly",
                                        width: "100%"
                                    }}
                                >

                                    <Button
                                        variant={"outlined"}
                                        style={{
                                            textTransform: 'none',
                                            marginTop: 50,
                                            borderRadius: 15
                                        }}
                                        onClick={() => {
                                            this.handleGoToPagos()}
                                        }
                                    >
                                        <Typography
                                            style={{
                                                color: "#4C494B",
                                                fontSize: 24,
                                                fontFamily: "Poppins",
                                                textAlign: "center",
                                                margin: 10
                                            }}
                                        >
                                            {this.state.text["33"]}
                                        </Typography>

                                    </Button>
                                </div>

                            </div>
                        }

                        {this.state.pagos && !this.state.pagar &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "flex-start",
                                    width: '100%',
                                    height: '70%',
                                    minWidth: 900,
                                    minHeight: 700
                                }}
                            >
                                <div
                                    style={{
                                        width: '100%',
                                        height: '100%'
                                    }}
                                >
                                    <Planes
                                        plan={this.state.plan}
                                        precio={this.state.precio}
                                        text={this.state.text}
                                        changePlan={this.changePlan}
                                        changePrecio={this.changePrecio}
                                        changeParcelas={this.changeParcelas}
                                        changeSuperficie={this.changeSuperficie}
                                        changeDuracion={this.changeDuracion}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-around",
                                        alignItems: "flex-start",
                                        width: "100%",
                                        height: 150
                                    }}
                                >

                                    <Button
                                        variant={"outlined"}
                                        style={{
                                            textTransform: 'none',
                                            marginTop: 50,
                                            borderRadius: 15
                                        }}
                                        onClick={() => this.setState({pagos: false})}
                                    >
                                        <Typography
                                            style={{
                                                color: "#4C494B",
                                                fontSize: 24,
                                                fontFamily: "Poppins",
                                                textAlign: "center",
                                                margin: 10
                                            }}
                                        >
                                            {this.state.text["32"]}
                                        </Typography>
                                    </Button>

                                    <Button
                                        variant={"outlined"}
                                        style={{
                                            textTransform: 'none',
                                            marginTop: 50,
                                            borderRadius: 15
                                        }}
                                        onClick={() => {
                                            if (this.state.plan === 0) {
                                                this.handleCreate()
                                            } else {
                                                this.setState({pagar: true})
                                            }
                                        }}
                                    >
                                        <Typography
                                            style={{
                                                color: "#4C494B",
                                                fontSize: 24,
                                                fontFamily: "Poppins",
                                                textAlign: "center",
                                                margin: 10
                                            }}
                                        >
                                            {this.state.plan === 0 ?
                                                this.state.text["34"]
                                                :
                                                this.state.text["33"]
                                            }
                                        </Typography>
                                    </Button>

                                </div>
                            </div>
                        }

                        {this.state.pagar &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    width: '90%',
                                    height: '70%',
                                    marginTop: 20
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                        width: '100%',
                                        height: 'calc(100% - 150px)'
                                    }}
                                >
                                    <Payments
                                        user={this.state.user}
                                        plan={this.state.plan}
                                        precio={this.state.precio}
                                        parcelas={this.state.parcelas}
                                        superficie={this.state.superficie}
                                        duracion={this.state.duracion}
                                        email={this.state.email}
                                        text={this.state.text}
                                        createAccount={this.createAccount}
                                        setContacta={this.props.setContacta}
                                        setUser={this.props.setUser}
                                        setGo2App={this.props.setGo2App}
                                        setLoading={this.setLoading}
                                        setEmail={this.setEmail}
                                        notify={this.props.notify}
                                        location={this.state.location}
                                    />
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "space-around",
                                        alignItems: "flex-start",
                                        width: "100%",
                                        height: 150
                                    }}
                                >

                                    <Button
                                        variant={"outlined"}
                                        style={{
                                            textTransform: 'none',
                                            marginTop: 50,
                                            borderRadius: 15
                                        }}
                                        onClick={() => this.setState({pagar: false})}
                                    >
                                        <Typography
                                            style={{
                                                color: "#4C494B",
                                                fontSize: 24,
                                                fontFamily: "Poppins",
                                                textAlign: "center",
                                                margin: 10
                                            }}
                                        >
                                            {this.state.text["32"]}
                                        </Typography>
                                    </Button>

                                    <div style={{width: 165}}/>

                                </div>
                            </div>
                        }

                        {this.state.pagar && this.state.loading &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: '100vw',
                                    height: '100vh',
                                    marginTop: '-80vh',
                                    backgroundColor: "rgba(255,255,255,0.5)"
                                }}
                            >
                                <CircularProgress
                                    style={{
                                        height: 80,
                                        width: 80,
                                        color: "#b43333"
                                    }}
                                />
                            </div>
                        }

                    </div>

                </div>
            </div>
        )

    }
}

const mapStateToProps = (state: IStore) => ({
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setContacta: (contacta: boolean) => dispatch({type: "set-login-contacta", contacta}),
    setUser: (user: string) => dispatch({type: "set-login-user", user}),
    setGo2App: (go2app: boolean) => dispatch({type: "set-go-to-app", go2app})
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileLoginCreate);
